import { render, staticRenderFns } from "./deviceRole_f.vue?vue&type=template&id=1bfc1c4e&"
import script from "./deviceRole_f.vue?vue&type=script&lang=js&"
export * from "./deviceRole_f.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports